import axios from '../../utils/AxiosUtils';
import i18n from '../../i18next';
import { LOADING, LOAD_ADMINS_SUCCESS } from '../types';
import { MENUU_ADMIN } from '../../utils/Constants';
import MessageUtils from "../../utils/MessageUtils";

export const loadAdmins = () => {
    return (dispatch, getState) => {
        doLoadAdmins(dispatch, getState);
    };
};

const doLoadAdmins = (dispatch, getState) => {
    dispatch({ type: LOADING, payload: true });

    const url = `/user/admin`;

    axios().get(url)
        .then(response => loadUsersSuccess(dispatch, response))
        .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:adminsActions.loadFailure')));
}

const loadUsersSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_ADMINS_SUCCESS, payload: response.data });
}

export const saveAdmin = (state) => {
    return (dispatch, getState) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/user`;

        const admin = {
            name: state.name,
            phone: state.phone,
            email: state.email,
            password: state.password,
            countryCode: state.countryCode,
            language: 'en',         //language: state.language,
            role: MENUU_ADMIN,
            active: true
        };

        axios().post(url, admin)
            .then(response => saveAdminSuccess(dispatch, getState, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.saveFailure')));
    };
};

export const updateAdmin = (state) => {
    return (dispatch, getState) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/user/${state.id}`;

        const admin = {
            id: state.id,
            name: state.name,
            phone: state.phone,
            email: state.email,
            password: state.password,
            countryCode: state.countryCode,
            language: 'en',        //language: state.language,
            role: MENUU_ADMIN,
            active: true
        };

        axios().put(url, admin)
            .then(response => saveAdminSuccess(dispatch, getState, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.saveFailure')));
    };
};


const saveAdminSuccess = (dispatch, getState, response) => {
    dispatch({ type: LOADING, payload: false });
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:adminsActions.saveUserSuccess'));

    doLoadAdmins(dispatch, getState, response);
};

export const deactivateAdmin = (adminStatus, adminId) => {
    return (dispatch, getState) => {

        dispatch({ type: LOADING, payload: true });
        const url = `/user/${adminId}/activate`;

        const data = {
            'flag': adminStatus
        }

        axios().put(url, data)
            .then(() => deactivateAdminSuccess(dispatch, getState, adminStatus))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:adminsActions.deactivateFailure')));
    };
};

const deactivateAdminSuccess = (dispatch, getState, adminStatus) => {
    dispatch({ type: LOADING, payload: false });
    if (adminStatus) {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:adminsActions.activateAdminSuccess'));
    } else {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:adminsActions.deactivateAdminSuccess'));
    }

    doLoadAdmins(dispatch, getState);
};


// WEBPACK FOOTER //
// ./src/actions/users/AdminsActions.js